import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from './authentication.service';
import { Pallet } from '../../agatextscreens/accounting/pallets/pallet';
import { Branch } from '../../agatextscreens/accounting/branch';

@Injectable()
export class PalletService {

  private _url = this._configuration.apiUrl + '/v2/pallet';

  constructor(
    private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService
  ) { }


  updatePallet(id:string, pallet: Pallet): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._http.put(this._url, pallet, { headers: h, search: s }).map(response => response.json());
  }


  createPallet(pallet: Pallet): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._url, pallet, { headers: h, search: s }).map(response => response.json());
  }

  /* limiting to one branch doesn't really make practical sense
  
      getPallets(branch: string): Observable<Pallet[]> {
  
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();
  
        if (branch) {
          s.append('branch', branch);
        }
  
        return this._http.get(this._url, { headers: h, search: s }).map(
          response => {
            let body = response.json();
  
            if (body['pallets'] == null || !Array.isArray(body['pallets'])) {
              return [];
            }
  
            return body['pallets'];
          }
        );
      }
      */

  getPallets(branch_id?: number): Observable<Pallet[]> {

    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (branch_id) {
      s.append('branch', branch_id.toString());
    }

    return this._http.get(this._url, { headers: h, search: s }).map(
      response => {
        let body = response.json();

        if (body['pallets'] == null || !Array.isArray(body['pallets'])) {
          return [];
        }

        return body['pallets'];
      }
    );
  }


  getPallet(pallet_id: string): Observable<Pallet> {

    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', pallet_id);

    return this._http.get(this._url, { headers: h, search: s }).map(

      response => {
        let body = response.json();
        if (body['pallets'] == null || !Array.isArray(body['pallets'])) {
          return [];
        }

        return body['pallets'][0];
      }
    );
  }


  getPalletByName(name: string): Observable<Pallet> {

    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('name', name);

    return this._http.get(this._url, { headers: h, search: s }).map(

      response => {
        let body = response.json();
        if (body['pallets'] == null || !Array.isArray(body['pallets'])) {
          return [];
        }

        return body['pallets'][0];
      }
    );
  }


}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/services/pallet.service.ts